import { FunctionFactory } from 'survey-core';
import { tSurvey } from '../i18n/survey';
import { makeSplashHeader } from './SplashHeader';
import { ProteinTracking } from '../quiz/protein';

const proteinSplashHtml = `
<div class="new-quote-container centered">
  <div class="splash-icon">{proteinIcon}</div>
  <div class="splash-header">
    <h1>{proteinTitle}</h1>
    <div class="quote">
      {proteinQuote}
    </div>
  </div>
</div> 
`;

const proteinSplashExpression = {
  name: "proteinQuote",
  expression: "renderProteinQuote({protein})",
};

function renderProteinQuote(params: any[]): string {
  if (params === undefined || params === null) return "";
  switch (params[0] as ProteinTracking) {
    case ProteinTracking.NoIdea:
      return tSurvey("splash.protein.quote.noIdea");
    case ProteinTracking.EatingMore:
    case ProteinTracking.PrettyClose:
      return tSurvey("splash.protein.quote.onTrack");

    case ProteinTracking.EatingLess:
      return tSurvey("splash.protein.quote.eatingLess");
  }
}

FunctionFactory.Instance.register("renderProteinQuote", renderProteinQuote);

const proteinSplashElement = {
  name: 'protein-splash',
  type: 'html',
  html: proteinSplashHtml,
}

function renderProteinTitle(params: any[]): string {
  if (params === undefined || params === null) return "";
  switch (params[0] as ProteinTracking) {
    case ProteinTracking.NoIdea:
      return tSurvey("splash.protein.title.noWorries");
    case ProteinTracking.EatingMore:
    case ProteinTracking.PrettyClose:
      return tSurvey("splash.protein.title.oneStepAhead");
    case ProteinTracking.EatingLess:
      return tSurvey("splash.protein.title.noWorries");
  }
}

FunctionFactory.Instance.register("renderProteinTitle", renderProteinTitle);

const proteinSplashTitleExpression = {
  name: "proteinTitle",
  expression: "renderProteinTitle({protein})",
};

function renderProteinIcon(params: any[]): string {
  if (params === undefined || params === null) return "";
  switch (params[0] as ProteinTracking) {
    case ProteinTracking.NoIdea:
      return "🍳";
    case ProteinTracking.EatingMore:
    case ProteinTracking.PrettyClose:
      return "🏅";
    case ProteinTracking.EatingLess:
      return "🪄";
  }
}

FunctionFactory.Instance.register("renderProteinIcon", renderProteinIcon);

const proteinSplashIconExpression = {
  name: "proteinIcon",
  expression: "renderProteinIcon({protein})",
};

const ProteinSplashHeader = makeSplashHeader("splash.headers.protein");
export {
  proteinSplashElement,
  proteinSplashExpression,
  ProteinSplashHeader,
  proteinSplashTitleExpression,
  proteinSplashIconExpression,
}
